import { render } from "./allOrders.vue?vue&type=template&id=40215851&scoped=true"
import script from "./allOrders.vue?vue&type=script&lang=js"
export * from "./allOrders.vue?vue&type=script&lang=js"

import "./allOrders.vue?vue&type=style&index=0&id=40215851&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40215851"]])

export default __exports__